/* eslint-disable no-unused-vars */
/* eslint-disable import/named */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable import/no-cycle */
/* eslint-disable react/self-closing-comp */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/img-redundant-alt */
import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Link, NavLink, useHistory } from "react-router-dom";
import firebase from "firebase";
import Swal from "sweetalert2";
import { IMAGES } from "../common/images";
import { ForgetPasswordModal } from "./forgetPasswordModal";
import { firebaseConfig } from "../firebase/firebase";
import { logoutUser } from "../redux/actions";
import { storePemissions } from "../redux/actions/permissions";

export const AsideBar = () => {
  const { doc } = useSelector((state) => state.userState);
  const { PermissionsList } = useSelector((state) => state.permissionsState);
  const [modalIsOpen, setIsOpen] = useState(false);
  const [profilePhoto, setProfilePhoto] = useState(false);
  const history = useHistory();
  const dispatch = useDispatch();

  const openModal = () => {
    setIsOpen(true);
  };

  const logout = () => {
    firebase
      .auth()
      .signOut()
      .then(() => {
        history.push("/");
        dispatch(logoutUser({ doc }));
        dispatch(storePemissions(PermissionsList));
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Email Or Password Is invalid!",
          confirmButtonText: "Close",
          confirmButtonColor: "#4e4e4e",
        });
      });
  };

  useEffect(() => {
    setProfilePhoto(IMAGES.Avatar);
    if (typeof doc.EmployeeAttachments !== "undefined") {
      doc.EmployeeAttachments.forEach((element) => {
        if (element.ImageType === "Profile Photo") {
          setProfilePhoto(element.FileURL);
        }
      });
    }
  }, []);

  return (
    <nav className="navbar navbar-light bg-white fixed-top">
      <div className="container-fluid">
        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="offcanvas"
          data-bs-target="#offcanvasNavbar"
          aria-controls="offcanvasNavbar">
          <span className="navbar-toggler-icon" />
        </button>
        <div className="user-panel mt-3 d-flex">
          <div className="image">
            <img src={profilePhoto} className="img-circle elevation-2" alt="User Image" />
          </div>
          <div className="info">
            <Link to="/profile" className="d-block text-dark text-decoration-none employee-profile">
              <h5> {doc?.EmployeeName} </h5>
            </Link>
          </div>
        </div>
        <div className="dropdown">
          <a
            className="btn btn-blue-grey dropdown-toggle"
            href="#"
            role="button"
            id="dropdownMenuLink"
            data-bs-toggle="dropdown"
            aria-expanded="false">
            Options
          </a>

          <ul className="dropdown-menu" aria-labelledby="dropdownMenuLink">
            <li>
              <a className="dropdown-item" onClick={openModal}>
                <i className="fas fa-lock"></i>
                Change Password
              </a>
            </li>
            <li className="border-bottom border-top">
              <a className="dropdown-item" onClick={logout}>
                <i className="fas fa-sign-out-alt"></i>
                Logout
              </a>
            </li>
            <li>
              <Link to="/profile" className="dropdown-item" href="#">
                <i className="far fa-id-badge"></i>
                profile
              </Link>
            </li>
          </ul>
        </div>

        <div
          className="offcanvas offcanvas-start"
          tabIndex={-1}
          id="offcanvasNavbar"
          aria-labelledby="offcanvasNavbarLabel">
          <div className="offcanvas-header border-bottom ">
            <div className="text-center d-flex justify-content-center align-items-center w-100">
              <h5 className="offcanvas-title" id="offcanvasNavbarLabel">
                <Link
                  to="/home-dashboard"
                  className="d-block text-dark text-decoration-none employee-profile navbar-brand d-flex justify-content-center align-items-center">
                  <img src={IMAGES.logo} alt="Logo" className="brand-image" />
                  <h4 className="pt-4">Truly Nolen</h4>
                </Link>
              </h5>
            </div>
            <button
              type="button"
              className="btn-close text-reset"
              data-bs-dismiss="offcanvas"
              aria-label="Close"
            />
          </div>
          <div className="offcanvas-body">
            <ul className="navbar-nav">
              {PermissionsList?.map((item, index) => {
                return (
                  <li className="nav-item">
                    <NavLink to={item.url} className="nav-link">
                      <i className={item.icon} />
                      <p>{item.label}</p>
                    </NavLink>
                  </li>
                );
              })}
            </ul>
          </div>
        </div>
      </div>
      <ForgetPasswordModal modalIsOpen={modalIsOpen} setIsOpen={setIsOpen} />
    </nav>
  );
};
